import { ref } from 'vue'

export const THEMES = ['default', 'light', 'dark', 'theme-1', 'theme-2', 'theme-3']
const STORAGE_KEY = 'theme'

function load() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    return THEMES.includes(saved) ? saved : 'default'
  } catch {
    return 'default'
  }
}

// module-level, so every component shares the same state
const theme = ref(load())

export function useTheme() {
  function setTheme(name) {
    if (!THEMES.includes(name)) return
    theme.value = name
    try { localStorage.setItem(STORAGE_KEY, name) } catch { /* ignore */ }
  }
  return { theme, setTheme }
}